import { makeStyles } from "tss-react/mui";
import { Theme247 } from "../styles/Theme247";
import {
  Breadcrumbs,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FilledInput,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  TextField,
} from "@mui/material";
import i18n from "../reducers/i18n";
import { useEffect, useState } from "react";
import { ApplyStyle as _s } from "../utils/ApplyStyle";
import { withCurrentAccountPrefix } from "../utils/accountMode";
import {
  Link,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ScopeHeader from "../components/ScopeHeader";

import { connect, useStore } from "react-redux";
import { createmachinePool } from "../actions/machines";
import { assignEquipmentPool } from "../actions/objects";

import store from "../store";
import { Search } from "@mui/icons-material";
import PoolcheckBoxesDialog from "./PoolCheckboxesDialog";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";

import "247factorynet-packages/dist/index.css";
import SafeMachineCardItem from "../components/SafeMachineCardItem";
import { truncateWithEllipses } from "../utils/helpers";
import machineFallbackImage from "../assets/machine-example.png";
import { hasMalfunction } from "../shared-functions/notification";

import {
  createEqPoolMap,
  getsitesareaeqs2,
  getallsitesareaeqs,
  setsitesareaeqs2Empty,
} from "../actions/objects";
import { updatemachinePool, deletemachinePool } from "../actions/machines";
import { useNavigate } from "react-router-dom";
import DeletePopUp from "../components/DeletePopup";
import { Stack } from "@mui/system";
import { uniqBy } from "lodash";

import LinkOffIcon from '@mui/icons-material/LinkOff';
import { getItem } from "../utils/DataProtection";


export default connect(
  ({ subscribedEquipments, subscribedEquipmentpools, allsitesareaseqs }) => ({
    subscribedEquipments,
    subscribedEquipmentpools,
    allsitesareaseqs,
  }),
  {
    createmachinePool,
    createEqPoolMap,
    getsitesareaeqs2,
    updatemachinePool,
    deletemachinePool,
    setsitesareaeqs2Empty,
    getallsitesareaeqs,
  }
)((props) => {
  const navigate = useNavigate();

  const useStyles = makeStyles()((theme) => ({
    elevatedSection: {
      ...Theme247.elevatedSection,
    },
  }));

  const { classes } = useStyles();

  const language = useStore().getState().language;

  const [poolModel, setPoolModel] = useState(false);

  const [selectedCheckBoxes, setSelectedCheckboxes] = useState(0);

  const [searchText, setSearchText] = useState("");

  const [disabled, setDisabled] = useState(false);

  const [filteredItems, setFilteredItems] = useState("");

  const [childModelData, setChildModelData] = useState([]);

  const [editPayload, setEditPayload] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams();

  const [defaultIds, setDefaultIds] = useState([]);

  const [modelData, setModelData] = useState([]);

  const [showSkeliton, setShowSkeliton] = useState(true);

  let editMode = searchParams.get("nodeid") !== null;

  let targetNodeId = searchParams.get("nodeid");
  let targetEqPool = editMode && props.subscribedEquipmentpools[targetNodeId];

  let defaultChecked = targetEqPool?.hasequipment
    ? targetEqPool.hasequipment.map((ids) => {
        return ids.equipment.nodeid;
      })
    : [];

  const [poolName, setPoolName] = useState(
    targetEqPool ? targetEqPool?.name : ""
  );

  const handleClick = () => {
    setPoolModel(true);
  };

  const [checkedItems, setCheckedItems] = useState({});

  // Example list of items you might want to render checkboxes for
  const items = [
    {
      id: "1",
      eqName: "Internal Equipment Name 1",
      eqId: "Equipment Id 1",
      brandName: "Brand Name 1",
      typIdentifier: "type identifier 1",
    },
    {
      id: "2",
      eqName: "Internal Equipment Name 2",
      eqId: "Equipment Id 2",
      brandName: "Brand Name 2",
      typIdentifier: "type identifier 2",
    },
    {
      id: "3",
      eqName: "Internal Equipment Name 3",
      eqId: "Equipment Id 3",
      brandName: "Brand Name 3",
      typIdentifier: "type identifier 3",
    },
    {
      id: "4",
      eqName: "Internal Equipment Name 4",
      eqId: "Equipment Id 4",
      brandName: "Brand Name 4",
      typIdentifier: "type identifier 4",
    },
  ];

  // To get the IDs of selected checkboxes
  const getSelectedCheckboxIds = () => {
    return Object.entries(checkedItems)
      .filter(([key, value]) => value)
      .map(([key]) => key);
  };

  const handleSearchTextChange = (e) => {
    let text = e.target.value;
    setSearchText(text);

    setFilteredItems(
      items.filter((item) => {
        return (
          item.eqName.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
          item.eqId.toLocaleLowerCase().includes(text.toLocaleLowerCase()) ||
          item.brandName
            .toLocaleLowerCase()
            .includes(text.toLocaleLowerCase()) ||
          item.typIdentifier
            .toLocaleLowerCase()
            .includes(text.toLocaleLowerCase())
        );
      })
    );
  };

  const [openDialogDelete, setopenDialogDelete] = useState();

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  const getCheckBoxData = (data) => {
    setChildModelData(data);
    let finalPayload = [];

    if (defaultChecked.length) {
      for (const [key, value] of Object.entries(data)) {
        //delete
        if (
          defaultChecked.includes(key) &&
          value === false &&
          targetEqPool.nodeid !== ""
        ) {
          finalPayload.push({
            equipmentnodeid: key,
            isequipmentof: [],
            deleteequipmentof: [{ type: "pool", nodeid: targetEqPool.nodeid }],
          });
        }

        //add
        if (
          !defaultChecked.includes(key) &&
          value === true &&
          targetEqPool.nodeid !== ""
        ) {
          finalPayload.push({
            equipmentnodeid: key,
            isequipmentof: [targetEqPool.nodeid],
            deleteequipmentof: [],
          });
        }
      }
    } else {
      for (const [key, value] of Object.entries(data)) {
        if (value === true) {
          //add
          finalPayload.push({
            equipmentnodeid: key,
            isequipmentof: [targetEqPool.nodeid],
            deleteequipmentof: [],
          });
        }
      }
    }

    setEditPayload(finalPayload);
  };

  const handleCreatePool = () => {
    setDisabled(true);
    props.createmachinePool({
      lang: store.getState().language,
      name: poolName,
      isequipmentpoolof: JSON.parse(getItem("legalentitynodeid")),
      assign: {
        payload: editPayload,
      },
    });

    // props.createEqPoolMap({
    //   payload: editPayload,
    // });

    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
      props.getallsitesareaeqs("", "ALL_SAE");
      navigate(withCurrentAccountPrefix("/machines"));
    }, [3000]);
  };

  const handleEditPool = () => {
    setDisabled(true);

    props.updatemachinePool({
      lang: store.getState().language,
      name: poolName,
      equipmentpoolnodeid: targetEqPool.nodeid,
    });

    props.createEqPoolMap({
      payload: editPayload,
    });

    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
    }, [3000]);
    navigate(withCurrentAccountPrefix("/machines"));
  };

  const handleDelete = () => {
    props.deletemachinePool({ equipmentpoolnodeid: targetEqPool.nodeid });

    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
      props.getallsitesareaeqs("", "ALL_SAE");
    }, [3000]);

    navigate(-1);
  };

  const getSelectedCheckBoxes = (ids) => {
    let eqs = [];
    Object.entries(props.subscribedEquipments).map((eqPool) => {
      let key = eqPool[0];
      let value = eqPool[1];
      if (ids.includes(value.nodeid)) {
        eqs.push(value);
      }
    });
    setDefaultIds(eqs);
  };

  useEffect(() => {
    props.setsitesareaeqs2Empty("", "ALL_SAE_EMPTY");
    props.getsitesareaeqs2("", "SAE2");
    props.getallsitesareaeqs("", "ALL_SAE");
    makeCheckBoxes();
    setTimeout(() => {
      setShowSkeliton(false);
    }, 2000);
  }, []);

  const makeCheckBoxes = () => {
    let modelData = [];

    props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite?.map(
      (siteItem, key) => {
        siteItem.site?.hasarea &&
          siteItem.site.hasarea.map((areaItem) => {
            areaItem.area?.hasequipment &&
              areaItem.area.hasequipment.map((eqItem, index) => {
                modelData.push({
                  id: eqItem.equipment.nodeid,
                  eqName: eqItem.equipment.name,
                  eqId: eqItem.equipment.equipmentid,
                  brandName: eqItem.equipment?.hasequipmenttype
                    ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.isequipmenttypeof[0]?.brand?.name
                    : "",
                  typIdentifier: eqItem.equipment?.hasequipmenttype
                    ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.model
                    : "",
                  className: "",
                });
              });
          });
      }
    );

    // Grab Equipments from pool

    props.allsitesareaseqs[0]?.data[0]?.legalentity.hasequipmentpool?.map(
      (poolItem, key) => {
        poolItem.equipmentpool?.hasequipment &&
          poolItem.equipmentpool.hasequipment.map((eqItem, index) => {
            modelData.push({
              id: eqItem.equipment.nodeid,
              eqName: eqItem.equipment.name,
              eqId: eqItem.equipment.equipmentid,
              brandName: eqItem.equipment?.hasequipmenttype
                ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                    ?.isequipmenttypeof[0]?.brand?.name
                : "",
              typIdentifier: eqItem.equipment?.hasequipmenttype
                ? eqItem?.equipment?.hasequipmenttype[0]?.equipmenttype?.model
                : "",
            });
          });
      }
    );

    if (modelData.length) {
      modelData[modelData.length - 1].className = "eqLast";
    }

    let unLinkedEquipments = getUnLinkedEquipments();

    if (unLinkedEquipments.length) {

      unLinkedEquipments[0].className = "eqUnlinked";
      modelData = [...modelData, ...unLinkedEquipments];
      modelData[modelData.length - 1].className = "eqLast";

    }

    setModelData(modelData);
  };

  const getUnLinkedEquipments = () => {
    let unlinkedEquipments = [];
    let allEquipments = getAllEquipments();

    let allLegalEntityEquipments = props.allsitesareaseqs[1]?.data[0]?.legalentity?.hasequipment;

    if (allLegalEntityEquipments?.length) {
      allLegalEntityEquipments.map(
        (eqItem) => {

          let targetEq = allEquipments.filter((eq=>{ return eq.id === eqItem.equipment.nodeid}))

          if (allEquipments && targetEq.length === 0) {
            unlinkedEquipments.push({
              id: eqItem.equipment.nodeid,
              eqName: eqItem.equipment.name,
              eqId: eqItem.equipment.equipmentid,
              brandName: eqItem.equipment?.hasequipmenttype
                ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                    ?.isequipmenttypeof[0]?.brand?.name
                : "",
              typIdentifier: eqItem.equipment?.hasequipmenttype
                ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype?.model
                : "",
              className: "",
              icon: <LinkOffIcon />
            });
          }
        }
      );
    }

    return unlinkedEquipments;
  };

  const getAllEquipments = () => {
    let equipments = [];

    // Grab Equipments from areas

    props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite?.map(
      (siteItem, key) => {
        siteItem.site?.hasarea &&
          siteItem.site.hasarea.map((areaItem) => {
            areaItem.area?.hasequipment &&
              areaItem.area.hasequipment.map((eqItem) => {
                equipments.push({
                  id: eqItem.equipment.nodeid,
                  eqName: eqItem.equipment.name,
                  eqId: eqItem.equipment.equipmentid,
                  brandName: eqItem.equipment?.hasequipmenttype
                    ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.isequipmenttypeof[0]?.brand?.name
                    : "",
                  typIdentifier: eqItem.equipment?.hasequipmenttype
                    ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.model
                    : "",
                });
              });
          });
      }
    );

    // Grab Equipments from pool

    props.allsitesareaseqs[0]?.data[0]?.legalentity.hasequipmentpool?.map(
      (poolItem, key) => {
        poolItem.equipmentpool?.hasequipment &&
          poolItem.equipmentpool.hasequipment.map((eqItem) => {
            equipments.push({
              id: eqItem.equipment.nodeid,
              eqName: eqItem.equipment.name,
              eqId: eqItem.equipment.equipmentid,
              brandName: eqItem.equipment?.hasequipmenttype
                ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                    ?.isequipmenttypeof[0]?.brand?.name
                : "",
              typIdentifier: eqItem.equipment?.hasequipmenttype
                ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype?.model
                : "",
            });
          });
      }
    );

    return equipments;
  };

  let uniqueMachines = uniqBy(modelData, "id");

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" className={_s(Theme247.breadcrumbs)}>
        <div
          onClick={() => {
            navigate(-1);
          }}
          style={{ color: "rgba(0, 0, 0, 0.38)", display: "flex" }}
        >
          <ArrowBackIcon size="large" />
          {i18n().backLink}
        </div>
      </Breadcrumbs>
      <PoolcheckBoxesDialog
        items={uniqueMachines}
        setPoolModel={setPoolModel}
        poolModel={poolModel}
        getCheckBoxData={getCheckBoxData}
        defaultChecked={defaultChecked}
        getSelectedCheckBoxes={getSelectedCheckBoxes}
      />
      <ScopeHeader
        bgColor="var(--color-primary)"
        bgImage="../images/bg1.webp"
        txtColor="#FFFFFF"
        title="Equipment Pools"
        description="Ihr Equipment (z.B. Maschinen, Geräte, etc.) ist Equipment Pools zugeordnet. Sie können beliebig viele Equipment Pools anlegen."
      />
      <Paper
        elevation={Theme247.elevationLow}
        className={classes.elevatedSection}
      >
        <div className="createSite">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="_title">
              {editMode
                ? "Equipment Pool editieren"
                : "Neuen Equipment Pool anlegen"}
            </div>

            <div>
              {editMode ? (
                <Button
                  variant="contained"
                  color="error"
                  size="large"
                  startIcon={<DeleteForeverOutlinedIcon />}
                  onClick={() => setopenDialogDelete(true)}
                  // className={_s(Theme247.submitButton)}
                  sx={{
                    width: "100%",
                    color: "rgba(255, 61, 0, 1)",
                    border: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRadius: "4px",
                    background: "#ffffff",
                    ":hover": { color: "#ffffff" },
                  }}
                >
                  {/* {i18n.delete}
                   */}
                  Pool löschen
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>

          <Grid container spacing={2} sx={{ margin: "20px 0px" }}>
            <Grid item xs={5} style={{ padding: 0 }}>
              <TextField
                required
                value={poolName}
                fullWidth
                onChange={(e) => {
                  setPoolName(e.target.value);
                }}
                label={"Name des Equipment Pools"}
                variant="outlined"
                helperText={"z.B.: Fräsen"}
              />
            </Grid>
          </Grid>

          <Divider orientation="horizontal" sx={{ margin: "30px 0px" }} />

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="footerTitle">
              <div>Zugeordnetes Equipment </div>
              <div className="bxShadow counterCircle">
                {targetEqPool?.hasequipment === undefined
                  ? "0"
                  : targetEqPool?.hasequipment
                  ? targetEqPool?.hasequipment?.length
                  : Object.values(childModelData).filter((val) => {
                      return val === true;
                    }).length}
              </div>
            </div>
            <div>
              <Button
                variant="outlined"
                onClick={() => {
                  handleClick();
                }}
              >
                Equipment AUSWÄHLEN
              </Button>
            </div>
          </div>

          {targetNodeId && showSkeliton ? (
            <Stack spacing={1}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "23px",
                  width: "100%",
                }}
              >
                <Skeleton
                  variant="rounded"
                  width={"50%"}
                  height={97}
                  animation="wave"
                  style={{ marginRight: "23px" }}
                />

                <Skeleton
                  variant="rounded"
                  width={"50%"}
                  height={97}
                  animation="wave"
                />
              </div>
            </Stack>
          ) : (
            ""
          )}

          <div className="eqPool">
            {/* {targetEqPool?.hasequipment
              ? targetEqPool.hasequipment.map((y) => {
                  return (
                    <MachineCardItem
             
                      title={truncateWithEllipses(
                        y?.equipment?.name[language] != undefined
                          ? y?.equipment?.name[language]
                          : y?.equipment?.name,
                        40
                      )}
                      description={` ${
                        y?.equipment?.hasequipmenttype[0]?.equipmenttype
                          ?.isequipmenttypeof !== undefined
                          ? y?.equipment?.hasequipmenttype[0]?.equipmenttype
                              ?.isequipmenttypeof[0]?.brand?.name
                          : ""
                      } ${
                        y?.equipment?.hasequipmenttype[0]?.equipmenttype?.model
                      }`}
                      imageSrc={
                        y?.equipment?.image != null &&
                        y?.equipment?.image.fileid !== ""
                          ? y?.equipment?.image.url
                          : machineFallbackImage
                      }
                      className=""
                    />
                  );
                })
              : ""} */}

            {defaultIds.map((y) => {
              return (
                <SafeMachineCardItem
                  borderColor={hasMalfunction(y?.hasnotification)}
                  title={truncateWithEllipses(
                    y?.name[language] != undefined
                      ? y?.name[language]
                      : y?.name,
                    40
                  )}
                  description={` ${
                    y?.hasequipmenttype &&
                    y?.hasequipmenttype[0]?.equipmenttype?.isequipmenttypeof !==
                      undefined
                      ? y?.hasequipmenttype[0]?.equipmenttype
                          ?.isequipmenttypeof[0]?.brand?.name
                      : ""
                  } ${y?.hasequipmenttype &&
                    y?.hasequipmenttype[0]?.equipmenttype?.model}`}
                  imageSrc={
                    y?.image != null && y?.image.fileid !== ""
                      ? y?.image.url
                      : machineFallbackImage
                  }
                  className=""
                />
              );
            })}
          </div>

          {/* <div className="eqPool_unsaved">
            {targetEqPool?.hasequipment
              ? targetEqPool.hasequipment.map((y) => {
                  return (
                    <MachineCardItem
                    
                      title={truncateWithEllipses(
                        y?.equipment?.name[language] != undefined
                          ? y?.equipment?.name[language]
                          : y?.equipment?.name,
                        40
                      )}
                      description={` ${
                        y?.equipment?.hasequipmenttype[0]?.equipmenttype
                          ?.isequipmenttypeof !== undefined
                          ? y?.equipment?.hasequipmenttype[0]?.equipmenttype
                              ?.isequipmenttypeof[0]?.brand?.name
                          : ""
                      } ${
                        y?.equipment?.hasequipmenttype[0]?.equipmenttype?.model
                      }`}
                      imageSrc={
                        y?.equipment?.image != null &&
                        y?.equipment?.image.fileid !== ""
                          ? y?.equipment?.image.url
                          : machineFallbackImage
                      }
                      className=""
                    />
                  );
                })
              : ""}
          </div> */}
        </div>
      </Paper>

      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
        topic="Equipment Pool"
      ></DeletePopUp>

      <Button
        variant="contained"
        disabled={disabled || poolName === ""}
        onClick={() => {
          editMode ? handleEditPool() : handleCreatePool();
        }}
        style={{ marginBottom: "15%" }}
      >
        {editMode ? "Änderungen speichern" : "Equipment Pool anlegen"}
      </Button>
    </>
  );
});
